<template>
  <nav class="product-header-nav">
    <div class="product-header-nav-container container">
      <div>
        <button
          :class="['header-nav-btn', { 'show-list': showProductList }]"
          @click="toggleShowProductList"
        >
          商品一覽
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            class="bi bi-caret-down-fill"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div v-if="showProductList" class="product-header-nav-product-list">
      <div class="container">
        <div
          class="product-nav-group-wrap"
          v-for="productGroup in productGroupList"
          :key="productGroup.id"
        >
          <h4 class="product-nav-category-title text-primary">
            {{ productGroup.title }}
          </h4>
          <div class="row">
            <div
              v-for="product in productGroup.productList"
              class="col-md-3"
              :key="`${product.name}${product.id}`"
            >
              <router-link v-if="isRoute" to="">{{ product.name }}</router-link>
              <a v-if="!isRoute" :href="product.routeTo">{{ product.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "productHeaderNav",
  props: ["activeLink"],
  data() {
    return {
      showProductList: false,
      productGroupList: [
        {
          id: 1,
          title: "營養補助食品",
          productList: [
            {
              id: 1,
              name: "富地滋DN膠原",
              isRoute: true,
              routeTo: "/products/1",
            },
            {
              id: 2,
              name: "富地滋樂活隨身包",
              isRoute: true,
              routeTo: "/products/2",
            },
            {
              id: 5,
              name: "新夢莎ED膠原蛋白飲EX",
              isRoute: true,
              routeTo: "/products/11",
            },
          ],
        },
        {
          id: 2,
          title: "保養品",
          productList: [
            {
              id: 3,
              name: "LU gia 高機能美容精華液",
              isRoute: true,
              routeTo: "/products/4",
            },
            {
              id: 4,
              name: "夢莎逆時雙效保養系列",
              isRoute: true,
              routeTo: "/products#productMousaSec",
            },
          ],
        },
        {
          id: 3,
          title: "其他",
          productList: [],
        },
      ],
    };
  },
  methods: {
    toggleShowProductList() {
      this.showProductList = !this.showProductList;
    },
  },
};
</script>
<style>
.header-nav-btn svg {
  transition: all 0.3s ease;
}

.header-nav-btn.show-list svg {
  transform: rotate(-180deg);
}
</style>
